import script from "./SmsRequestFields.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsRequestFields.vue?vue&type=script&setup=true&lang=js"

import "./SmsRequestFields.vue?vue&type=style&index=0&id=a4f47086&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4f47086"]])

export default __exports__